export default __webpack_public_path__ + "static/media/e9d0122bbfb7a0e0a6d47f237ad03104.svg";